// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__H99x_","header":"styles_header__HH4yv","action":"styles_action__IJZXH","button":"styles_button__3OL0h"};